/** @format */

import React from "react";
import { Form, Icon, Image } from "semantic-ui-react";
import { convertToBEDate } from "../../../utils/tsUtils";
import { saveAs } from "file-saver";
import DisplayContentImage from "./DisplayContentImage";
import DisplayContentFile, { getContentFileName } from "./DisplayContentFile";
import ButtonDownloadFile from "./ButtonDownloadFile";
import moment from "moment";

export const isValidHttpUrl = (plaintext) => {
  let url;
  try {
    url = new URL(plaintext);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};

const isMobile = () => {
  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return isMobile;
};

export const downloadOrOpenFile = (data: {
  content?: string;
  content_file?: string;
  downloadFile?: boolean;
}) => {
  const dateNow = moment().format("DD_MM_YYYY");
  const fileName = getContentFileName(data.content);

  if (data.downloadFile || fileName) {
    saveAs(data.content_file, fileName || `file_${dateNow}`);
  } else {
    let newUrl = data.content_file;
    if (isMobile()) {
      newUrl = newUrl.includes("?")
        ? `${newUrl}&openExternalBrowser=1`
        : `${newUrl}?openExternalBrowser=1`;
    }
    window.open(`${newUrl}`);
  }
};

interface MyMessageProps {
  isBot: boolean;
  isMobile: boolean;
  isSelected: boolean;
  onSelect: () => void;
  onOpenVideoCall: () => void;
  onNavigationMessage: () => void;
  onClickLink: () => void;
  downloadFile: boolean;
  language: string;
  showAuthorName?: boolean;
  showFileSize?: boolean;
  isMediaViewer?: boolean;
  onLoadImage?: (id: any) => void;
}

const DEFAULT_PROPS = {
  isBot: false,
  isMobile: false,
  isSelected: false,
  onSelect: () => {},
  onOpenVideoCall: ({ url }) => {},
  onNavigationMessage: ({ content = "" }) => content,
  onMobileOpenImage: () => {},
  onClickLink: () => {},
  downloadFile: false,
  language: "th-TH",
};
const MyMessage = (propsParam: MyMessageProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(
      Object.entries(propsParam).filter(([_, value]) => value !== undefined)
    ),
  };


  const dateFormat = "DD/MM/YYYY";
  const generateRead = () => {
    if (props.message.user_read_count > 1) {
      return props.showAuthorName ? "" : "Read";
      // return <>{`Read ${props.message.user_read_count}`}</>;
    } else if (props.message.user_read_count > 0) {
      return props.showAuthorName ? "" : "Read";
    } else if (props.message.hasOwnProperty("sendFail")) {
      if (props.message.sendFail) {
        return "Failed";
      }
      // else {
      //   return "Delivering";
      // }
    }
    // else {
    //   return "Delivered";
    // }
  };

  const createMessage = () => {
    if (props.message.content_type === "file") {
      return (
        <DisplayContentFile
          content={props.message.content}
          file={props.message.content_file}
          isMediaViewer={props.isMediaViewer}
          showFileSize={props.showFileSize}
        />
      );
    } else if (props.message.content_type === "image") {
      if (!props.message.content_file) {
        return "Unable to get Image";
      }
      if (typeof props.message.content_file === "object") {
        return <Image src={URL.createObjectURL(props.message.content_file)} />;
      }
      return (
        <DisplayContentImage
          id={props.message.id}
          isMediaViewer={props.isMediaViewer}
          isMobile={props.isMobile}
          src={props.message.content_file}
          onLoadImage={props.onLoadImage}
        />
      );
    } else if (props.message.content_type === "vid_call") {
      return <Icon name="call square" size="big" color="green" />;
    } else if (props.message.content_type === "end_call") {
      return <Icon name="call square" size="big" color="grey" />;
    } else if (props.message.content_type === "navigation") {
      return props.onNavigationMessage({
        content: props.message.content,
        contentPayload: props.message.content_payload,
        contentType: props.message.content_type,
      });
    } else {
      // text_hyper_link is custom type for teleDesktop
      if (
        props.message.content.includes("http") &&
        props.message.content.includes("/form/") &&
        !props.isMobile
      ) {
        return props.onNavigationMessage({
          content: props.message.content,
          contentPayload: props.message.content_payload,
          contentType: "text_hyper_link",
        });
      } else if (props.message.content.includes("http")) {
        let listMsg = props.message.content.split(" ");
        // console.log("listMsg", listMsg);
        let Linkify = listMsg.map((item) => {
          if (!item.startsWith("http") && item.includes("http")) {
            let startIdx = item.indexOf("http");
            if (startIdx > 0) {
              let normalText = item.slice(0, startIdx);
              // console.log("normalText:", normalText);
              let urlText = item.slice(startIdx);
              console.log("href urlText:", urlText);
              return (
                <>
                  <>
                    {normalText}
                    <a
                      href={urlText}
                      style={{ position: "relative" }}
                      onClick={props.onClickLink}
                      onMouseDown={props.onClickLink}
                      onContextMenu={props.onClickLink}
                    >
                      {urlText}
                    </a>
                  </>
                </>
              );
            }
          }
          console.log("href item", item);
          return isValidHttpUrl(item) ? (
            <a
              href={item}
              style={{ position: "relative" }}
              onClick={props.onClickLink}
              onMouseDown={props.onClickLink}
              onContextMenu={props.onClickLink}
            >
              {" "}
              {item}{" "}
            </a>
          ) : (
            <> {item} </>
          );
        });

        return Linkify;
      } else {
        return props.message.content;
      }
    }
  };

  return (
    <Form className="MyMessage">
      {props.showAuthorName && props.message.author?.full_name && (
        <div
          style={{
            direction: "rtl",
            display: "flex",
            fontSize: "13.75px",
            marginRight: "4px",
          }}
        >
          {props.message.author?.full_name}
        </div>
      )}
      <Form.Group inline style={{ margin: 0 }}>
        <Form.Field
          className={
            "content" +
            (props.isSelected ? " selected " : "") +
            (props.isBot ? " chatbot " : "")
          }
          style={{ direction: "initial", maxWidth: "500px" }}
          {...(props.isMobile &&
            props.message.content_type === "file" && {
              href: props.message.content_file,
            })}
          onClick={() => {
            // props.onSelect(props.message.id)
            if (props.message.sendFail) {
              props.onResend({ message: props.message });
            }
            if (props.message.content_type == "vid_call" && !props.isMobile) {
              props.onOpenVideoCall({ url: props.message.content });
            }
            if (props.message.content_type === "file") {
              downloadOrOpenFile({
                downloadFile: props.downloadFile,
                ...props.message,
              });
            }
            if (props.isMobile && props.message.content_type === "image") {
              props.onMobileOpenImage(props.message.content_file);
            }
          }}
        >
          {createMessage()}
        </Form.Field>
        <Form.Field
          className={"sendDateTime" + (props.isBot ? " chatbot " : "")}
        >
          {generateRead()}
          {props.message.send_at ? (
            <>
              <div style={{ margin: 0 }}>
                {props.message.send_at.split(" ")[1]}
                {props.showAuthorName && generateRead() === "" && (
                  <label style={{ marginRight: "2px" }}>
                    <MessageReadIcon />
                  </label>
                )}
              </div>
              <div>
                {props.language === "th-TH"
                  ? convertToBEDate({
                      date: props.message.send_at.split(" ")[0],
                    })
                  : moment(
                      props.message.send_at.split(" ")[0],
                      dateFormat
                    ).format(dateFormat)}
              </div>
            </>
          ) : props.message.sendFail ? (
            <Icon
              name="redo"
              onClick={() => props.onResend({ message: props.message })}
            />
          ) : (
            <Icon name="reply" />
          )}
        </Form.Field>
      </Form.Group>
      <ButtonDownloadFile
        content={props.message.content}
        contentFile={props.message.content_file}
        contentType={props.message.content_type}
        showFileSize={props.showFileSize}
      />

      {/* <Form.Group
        style={{ margin: 0, display: props.isSelected ? null : "none" }}
      >
        {generateRead()}
      </Form.Group> */}
    </Form>
  );
};

const MessageReadIcon = () => (
  <svg
    fill="none"
    height="12"
    viewBox="0 0 18 12"
    width="18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.9L4.143 10.5L12 1.5M17 1.563L8.428 10.563L8 10"
      stroke="var(--primary-theme-color)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default React.memo(MyMessage);
